import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import styled from 'styled-components';

import areaFormat from 'lib/areaFormat';
import { sortByAvailableAndFloor } from 'lib/utils';
import {
	Container,
	FilterButton,
	BuildingSpaceLink,
} from './styles';

import {
	Table,
	Row,
	Cell,
	Heading,
} from 'lib/table';

const SpaceTable = styled(Table)`
	flex-direction: row;
	overflow-y: auto;
`;

class Spaces extends React.Component {
	state = {
	  showFilteredSpaces: false,
	}

	filteredSpacesToggleHandler = () => {
	  this.setState({ showFilteredSpaces: !this.state.showFilteredSpaces });
	}

	componentWillReceiveProps(nextProps) {
	  if (nextProps.activeFilters.length !== this.props.activeFilters.length) {
	    this.setState({ showFilteredSpaces: false });
	  }
	}

	shouldComponentUpdate(nextProps, nextState) {
	  return (
	    this.props.activeFilters.length !== nextProps.activeFilters.length ||
			this.props.onlyFree !== nextProps.onlyFree ||
			this.state.showFilteredSpaces !== nextState.showFilteredSpaces
	  );
	}

	render() {
	  const { t, language, spaces, activeFilters, onlyFree } = this.props;
	  const typeFilters = activeFilters.filter(filter => filter.type === 'spaceType');
	  const areaFilters = activeFilters.filter(filter => filter.type === 'area');

	  const allSpaces = [ ...spaces ].filter(space => typeof space !== 'string');

	  const filteredSpaces = allSpaces
	    .filter(space => {
	      let show = true;

	      if (typeFilters.length) {
	        let showSpaceType = false;

	        typeFilters.forEach((filter, filterIndex) => {
	          showSpaceType = showSpaceType || filter.value === space.type;
	        });

	        show = showSpaceType;
	      }

	      if (areaFilters.length === 2) {
	        const min = areaFilters.find(filter => filter.key === 'min');
	        const max = areaFilters.find(filter => filter.key === 'max');


	        if (onlyFree) {
	          show = show && space.area >= min.value && space.area <= max.value && space.isFree;

	        } else {
	          show = show && space.area >= min.value && space.area <= max.value;
	        }
	      } else {
	        areaFilters.forEach(filter => {
	          if (filter.key === 'min') { show = show && Number(space.area) >= filter.value; }
	          if (filter.key === 'max') { show = show && Number(space.area) <= filter.value; }
	        });
	      }

	      if (onlyFree) {
	        show = show && space.isFree;
	      }

	      return this.state.showFilteredSpaces || show;
	    })
	    .sort(sortByAvailableAndFloor);

	  const spaceItems = filteredSpaces.map((space, i) => {
	    const name = space.i18n[language].name;
	    const type = t('space-type/' + space.type);
	    let area = areaFormat(space.area);
	    let freeText = space.isFree ? t('building/spaces/Yes') : t('building/spaces/No');

	    const freeFrom = new Date(space.free_from);
	    const now = new Date();

	    if (
	      !isNaN(freeFrom.getFullYear()) &&
				freeFrom.getFullYear() > 2000 &&
				freeFrom.getTime() > now.getTime()
	    ) {
	      let dateString = '';
	      const year = freeFrom.getFullYear();

	      dateString = `${freeFrom.getDate()}.${freeFrom.getMonth()}.`;

	      if (year !== now.getFullYear()) {
	        dateString += year;
	      }

	      freeText += ` (${dateString})`;
	    }

			area = area + (area !== '' ? ' m²' : '');

			const spacePDFHandler = (e) => {
				e.preventDefault();
				window.open(space.default_brochure_pdf, '_blank');
			};

			const spaceName = name === '' ? type : name;
			const spaceNameHtml = space.default_brochure_pdf ? <BuildingSpaceLink onClick={spacePDFHandler} title={space.default_brochure_pdf}>{spaceName}</BuildingSpaceLink> : spaceName;

	    return (
	      <Row key={space.slug + i}>
	        <Cell style={{ width: '20%' }}>{space.floor}</Cell>
	        <Cell style={{ width: '40%' }} title={type}>{spaceNameHtml}</Cell>
	        <Cell style={{ width: '20%' }}>{freeText}</Cell>
	        <Cell style={{ width: '20%' }} end="true">{area}</Cell>
	      </Row>
	    )
	  });
	  const hiddenSpaces = allSpaces.length - filteredSpaces.length;

	  return (
	    <Container>
	      <SpaceTable>
	        <Row style={{ overflowY: 'scroll' }}>
	          <Heading style={{ width: '20%' }}>{t('browse/Building/List/Floor')}</Heading>
	          <Heading style={{ width: '40%' }}>{t('browse/Building/List/Space')}</Heading>
	          <Heading style={{ width: '20%' }}>{t('browse/Building/List/Free')}</Heading>
	          <Heading style={{ width: '20%' }} end="true">m²</Heading>
	        </Row>
	      </SpaceTable>
	      <SpaceTable style={{ maxHeight: hiddenSpaces > 0 ? '260px' : '300px' }}>
	        {spaceItems}
	      </SpaceTable>
	      {
	        hiddenSpaces > 0 &&
					<FilterButton
					  onClick={e => {
					    e.preventDefault();
					    this.filteredSpacesToggleHandler();
					  }}>
					  {t('browse/Building/List/Spaces/Filtered spaces', { count: hiddenSpaces })}
					</FilterButton>
	      }
	    </Container>
	  )
	}
}

Spaces.propTypes = {
	spaces: PropTypes.array,
	language: PropTypes.oneOf(['fi', 'en']),
	activeFilters: PropTypes.array,
	onlyFree: PropTypes.bool,
	t: PropTypes.func,
}

export default translate('translations')(Spaces);
